module.exports = __webpack_public_path__ + "img/25_stan.28be47b1.jpg";